import { render, staticRenderFns } from "./WhatsappDetail.vue?vue&type=template&id=7af9f4fb&scoped=true&"
import script from "./WhatsappDetail.vue?vue&type=script&lang=js&"
export * from "./WhatsappDetail.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappDetail.vue?vue&type=style&index=0&id=7af9f4fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af9f4fb",
  null
  
)

export default component.exports